
import { createI18n } from 'vue-i18n'
import { loadLanguage } from './services/data/cms-i18n'

/* remove the dynamic loading, as it loads after component created */
const loadI18n = async () => {
  const en = await loadLanguage();

  return createI18n({
    legacy: false,
    locale: import.meta.env.VITE_APP_I18N_LOCALE || 'en',
    fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'en',
    globalInjection: true,
    messages: { en: en.biobrowser } // : {en: {'hi': 'Hello World'}} // localMsg
  });
}
export default loadI18n;
